import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const CalculationKeyboardRoot = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'grid w-full grid-cols-8 grid-rows-2 gap-[1px] border-b border-gray-100',
      className
    )}
    {...props}
  />
)
